import React from 'react'
import { useNavigate } from 'react-router-dom'
import { BpButton } from '../../../shared/components/buttons/bp-button/BpButton'
import illustration from '../../../shared/assets/trademark-missing-stub-illustration.svg'
import { AddTrademarkModal } from '../../../pages/project/widgets/project-trademarks/AddTrademarkModal'
import { setModal } from '../../../app/store/reducers/AppSlice'
import { useAppDispatch } from '../../../app/store/hooks/Redux'
import { StubContactLinks } from './StubContactLinks'

interface TrademarkMissingStubProps {
  project: string
  changeLocation?: boolean
}

export const TrademarkMissingStub = ({
  project,
  changeLocation = false,
}: TrademarkMissingStubProps) => {
  const navigate = useNavigate()
  const dispatch = useAppDispatch()

  return (
    <div className={'flex justify-center'}>
      <div className={'flex w-full max-w-[320px] flex-col items-center gap-[24px]'}>
        <div className={'w-full'}>
          <img alt={'Illustration'} className={'mx-auto max-w-full'} src={illustration} />
        </div>
        <div className={'flex w-full flex-col gap-[16px]'}>
          <div
            className={'flex w-full flex-col gap-[16px] rounded-[16px] bg-focus/[0.06] p-[16px]'}
          >
            <p className={'text-center text-focus-500'}>
              See all ads infringing on your trademark, take action and watch them disappear from
              your branded SERP
            </p>
          </div>
          <div className={'flex justify-center'}>
            <BpButton
              className={'uppercase'}
              size={'md'}
              onClick={() => {
                changeLocation && navigate(`/projects/${project}/trademarks`)

                if (!project) return

                dispatch(
                  setModal({
                    children: (
                      <AddTrademarkModal
                        data={{
                          project_id: Number(project),
                        }}
                      />
                    ),
                  }),
                )
              }}
            >
              ADD TRADEMARK
            </BpButton>
          </div>
        </div>
        <div className={'flex flex-col gap-[8px]'}>
          <p className={'text-center text-[15px] text-[#8E7CA7]'}>Contact us for help</p>
          <StubContactLinks />
        </div>
      </div>
    </div>
  )
}
